import { render, staticRenderFns } from "./anuncio.vue?vue&type=template&id=5284648d&scoped=true&"
import script from "./anuncio.vue?vue&type=script&lang=js&"
export * from "./anuncio.vue?vue&type=script&lang=js&"
import style0 from "./anuncio.vue?vue&type=style&index=0&id=5284648d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284648d",
  null
  
)

export default component.exports